import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  children,
  className = '',
  fullWidth = false,
  href,
  ...props
}: ButtonProps) {
  const baseClasses = `
    inline-flex items-center justify-center
    bg-brand-gold hover:bg-brand-gold-hover
    text-brand-navy font-heading font-semibold text-lg md:text-xl
    py-4 px-8 rounded-full shadow-sm hover:shadow-md
    transition-all duration-300 ease-in-out cursor-pointer
    ${fullWidth ? 'w-full' : ''}
    ${className}
  `;
  if (href) {
    return <a href={href} className={baseClasses} onClick={props.onClick as any} data-id="element-107">
        {children}
      </a>;
  }
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (props.onClick) {
      props.onClick(e);
    } else {
      document.getElementById('offer-section')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <button className={baseClasses} {...props} onClick={handleClick} data-id="element-108">
      {children}
    </button>;
}